import {BenchlingAction} from 'redux-stores/Action';

import {ChemistryMoleculeVersionActionType} from './MoleculeVersionReduxActions';

interface MoleculeVersionUIState {
  moleculeVersionId: string;
}

export interface MoleculeVersionUIsState {
  [moleculeId: string]: MoleculeVersionUIState;
}

const MOLECULE_VERSION_UIS_INITIAL_STATE = {};

export default function reduceMoleculeVersionUIs(
  state: MoleculeVersionUIsState = MOLECULE_VERSION_UIS_INITIAL_STATE,
  action: BenchlingAction
): MoleculeVersionUIsState {
  switch (action.type) {
    case ChemistryMoleculeVersionActionType.CHEMISTRY_UPDATE_MOLECULE_VERSION: {
      return {
        ...state,
        [action.moleculeId]: {
          ...state[action.moleculeId],
          moleculeVersionId: action.moleculeVersionId,
        },
      };
    }
    default:
      return state;
  }
}
